import { PROVIDE_LABEL_OPTIONS } from './exchanges';

export const BACKUP_LABEL_METHODS = [PROVIDE_LABEL_OPTIONS.PRINT, PROVIDE_LABEL_OPTIONS.LABELLESS, PROVIDE_LABEL_OPTIONS.MAIL];

export const WHOLE_FOODS_RETURN_METHODS = [PROVIDE_LABEL_OPTIONS.WFM_PACKAGELESS];

export const UPS_RETURN_METHODS = [
  PROVIDE_LABEL_OPTIONS.UPS_PACKAGELESS,
  PROVIDE_LABEL_OPTIONS.EMAIL,
  PROVIDE_LABEL_OPTIONS.LABELLESS,
  PROVIDE_LABEL_OPTIONS.PICKUP,
  PROVIDE_LABEL_OPTIONS.PRINT,
  PROVIDE_LABEL_OPTIONS.MAIL,
  PROVIDE_LABEL_OPTIONS.ANY_CARRIER
];

export const LABEL_OPTIONS_VALUE_ALIAS_MAPPING = {
  UPSDropOff: PROVIDE_LABEL_OPTIONS.PRINT,
  LabelLess_UPSZapposDropOff: PROVIDE_LABEL_OPTIONS.LABELLESS,
  UPSZapposPickup: PROVIDE_LABEL_OPTIONS.PICKUP,
  PackageLess_UPSZapposDropOff: PROVIDE_LABEL_OPTIONS.UPS_PACKAGELESS,
  PackageLess_WFMZapposDropOff: PROVIDE_LABEL_OPTIONS.WFM_PACKAGELESS
};

export const RETURN_TRANSPORT_PLAN_NAME = {
  UPSDropOff: 'UPSDropOff',
  LabelLess_UPSZapposDropOff: 'LabelLess_UPSZapposDropOff',
  UPSZapposPickup: 'UPSZapposPickup',
  PackageLess_UPSZapposDropOff: 'PackageLess_UPSZapposDropOff',
  PackageLess_WFMZapposDropOff: 'PackageLess_WFMZapposDropOff',
  AnyCarrier: 'AnyCarrier'
};
